import BaseNormalizer from "./BaseNormalizer";

const documentAttachmentNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "filename",
  "mime_type",
  "downloadUrl",
  "meta",
]);

export default documentAttachmentNormalizer;
